module.exports = "/images/aerial-18.jpg";